import { PayloadAction } from '@reduxjs/toolkit';
import { DocumentDetails } from '../models/CommonTypes';

export type ReplaceFilePlayloadAction = {
  oldFile: DocumentDetails;
  newFile: DocumentDetails;
};

export interface AttachmentState {
  attachments: DocumentDetails[];
}

export const attachmentDefaultState = {
  attachments: [],
};

export const addAttachment = (
  state: AttachmentState,
  actions: PayloadAction<DocumentDetails>,
) => {
  state.attachments.push(actions.payload);
};

export const removeAttachment = (
  state: AttachmentState,
  actions: PayloadAction<DocumentDetails>,
) => {
  state.attachments = state.attachments.filter(
    (attachment) => actions.payload.documentName !== attachment.documentName,
  );
};

export const replaceAttachment = (
  state: AttachmentState,
  actions: PayloadAction<ReplaceFilePlayloadAction>,
) => {
  state.attachments = state.attachments.filter(
    (attachment) =>
      actions.payload.oldFile.documentName !== attachment.documentName,
  );
  state.attachments.push(actions.payload.newFile);
};

/**
 * Helpers Methods
 * */

/**
 * Converts the file to DocumentDetails object
 * @param documentId the dms uploaded id
 * @param file the file uploaded in the browser
 * @returns DocumentDetails object.
 */
export const convertFileToDocumentDetails = (
  documentId: string,
  file: File,
): DocumentDetails => {
  return {
    documentId: documentId,
    documentName: file.name,
    documentSizeInKB: file.size / 1000,
    documentType: file.type,
  };
};
